// This file was automatically generated from locateAccount.html.
// Please don't edit this file by hand.

goog.provide('el8.template.multiuser_access.locateAccount');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.multiuser_access.locateAccount.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8FormBox el8BoxWithHeading el8FaxFlow mt15p"><img src="/static/images/e-circle-blue.png?v=20160729" style="width:40px;position:absolute;right:25px;top:20px;" /><h3 class="el8BrandColor el8LightWeight el8AlignCenter">Log In to View Charts in Elation</h3><div class="el8MdSpacer"></div><h4 class="el8AlignCenter mbMd">Locate your account</h4><div class="w80p el8FormHorizontal el8CenterBlock"><form id="main-form"><div class="el8ErrorAlert">Can\'t find an account matching the information below</div><div class="el8FormGroup el8Row"><label class="el8Col4 el8StandardInputLabel">Your Last Name</label><div class="el8Col7"><input name="lastName" type="text" class="el8StandardInput" placeholder="Last Name"></input></div><div class="el8Col1"></div></div><div class="el8FormGroup el8Row"><label class="el8Col4 el8StandardInputLabel">Practice Fax Number</label><div class="el8Col7"><input name="fax" type="text" class="el8StandardInput" placeholder="###-###-####"></input></div></div><div class="el8SmSpacer"></div><div class="el8AlignCenter"><button id="locate-my-account" class="el8Btn el8BtnPrimary">Locate my account</button></div></form></div><div class="el8LgSpacer"></div><div class="account-chooser-container w70p el8CenterBlock"></div><div class="el8LgSpacer"></div></div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.multiuser_access.locateAccount.accountChooser = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.accounts.length) ? '<div class="el8InfoAlert">Multiple matches found, select your account below:</div>' : '', '<ul class="el8BtnList">');
  var accountList79 = opt_data.accounts;
  var accountListLen79 = accountList79.length;
  for (var accountIndex79 = 0; accountIndex79 < accountListLen79; accountIndex79++) {
    var accountData79 = accountList79[accountIndex79];
    output.append('<li><a href="', soy.$$escapeHtml(accountData79.signinUrl), '" class="el8Btn el8BtnDefault el8BtnBlock">', soy.$$escapeHtml(accountData79.name), (accountData79.address) ? ' at ' + soy.$$escapeHtml(accountData79.address) : '', '</a></li>');
  }
  output.append('</ul>');
  if (!opt_sb) return output.toString();
};
